const routes = [
  {
    path: 'aggridchart',
    name: 'aggridchart',
    component: () => import(/* webpackChunkName: "aggridchart" */ '@/modules/aggridchart/index.vue')
  },
];

export default routes;